<template>
  <div>
    <tjhclb />
  </div>
</template>

<script>
// 获取接口地址
import tjhclb from '@/components/tjhc/tjhclb'
export default {
  name: 'Tjhc',
  components: {
    // sideMenu,
    // Header,
    tjhclb
  },
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style scoped>
</style>
